import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isModalOpen: false,
  attributes: [],
  lastChanged: {
    attribute: "",
    value: "",
    image: null,
  },
  removedSelections: [],
  addedSelections: [],
  previousConfig: {},
  currenConfig: {},
}

const invalidSelectionSlice = createSlice({
  name: "invalidSelection",
  initialState,
  reducers: {
    setInvalidSelection(state, action) {
      state.attributes = action.payload.attributes
    },
    setModalOpen(state, action) {
      state.isModalOpen = action.payload
    },
    setCurrentConfig(state, action) {
      state.currenConfig = action.payload
    },
    setPreviousConfig(state, action) {
      state.previousConfig = action.payload
    },
    setLastChangedSelection(state, action) {
      state.lastChanged = {
        attribute: action.payload.attribute,
        value: action.payload.value,
        image: action.payload.image ?? null,
      }
    },
    setRemovedSelections(state, action) {
      state.removedSelections = action.payload
    },
    setAddedSelections(state, action) {
      state.addedSelections = action.payload
    },
    resetInvalidSelection(state) {
      state.isModalOpen = false
      state.attributes = []
      state.lastChanged = { attribute: "", value: "", image: null }
      state.removedSelections = []
      state.addedSelections = []
      state.previousConfig = {}
      state.currenConfig = {}
    },
  },
})

export const {
  setInvalidSelection,
  setModalOpen,
  resetInvalidSelection,
  setLastChangedSelection,
  setRemovedSelections,
  setAddedSelections,
  setCurrentConfig,
  setPreviousConfig,
} = invalidSelectionSlice.actions
export default invalidSelectionSlice
